import { Button, Modal } from "react-bootstrap"
import React, { useState } from "react"
import { FormattedMessage } from "react-intl"
import ActionButton from "../../button/actionbutton.component"
import RowCustomStatus from "../../../state/pricing/rowcustomstatus/RowCustomStatus"
import RowCustomStatusDropdownComponent from "../../../pricing/rowcustomstatus/component/RowCustomStatusDropdownComponent"

type Payload = {
    rowCustomStatusId: string
}

type Props = {
    show: boolean
    rowCustomStatuses: RowCustomStatus[]
    onSaveCallback: (payload: Payload) => void
    onCloseCallback: () => void
}

const ItemBulkUpdateRowCustomStatusModal = (props: Props) => {
    if (props.rowCustomStatuses.length == 0) return <></>
    const [selectedRowCustomStatusID, setSelectedRowCustomStatusID] = useState(props.rowCustomStatuses[0].getId())

    return (
        <Modal show={props.show} onHide={props.onCloseCallback} centered={true}>
            <Modal.Header closeButton>
                <Modal.Title>
                    <h5 className="modal-title pb-0 mb-0 border-0" id="setAssignedUserModalLabel">
                        <FormattedMessage
                            id="quote.component.item_bulk_update_row_custom_status_modal_title"
                            defaultMessage="Row Status"
                        />
                    </h5>
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div className="container-fluid">
                    <RowCustomStatusDropdownComponent
                        selectedRowCustomStatusID={selectedRowCustomStatusID}
                        rowCustomStatuses={props.rowCustomStatuses}
                        onSelectCallback={(id: string) => { setSelectedRowCustomStatusID(id) }} />
                </div>
            </Modal.Body>

            <Modal.Footer>
                <Button type="button" className="btn btn-secondary" onClick={props.onCloseCallback}>
                    <FormattedMessage
                        id="pricing.row_custom_status.component.new_custom_status_modal.close"
                        defaultMessage="Close" />
                </Button>

                <ActionButton type="button"
                    className="btn btn-primary"
                    onClick={() => props.onSaveCallback({ rowCustomStatusId: selectedRowCustomStatusID })}>
                    <FormattedMessage
                        id="pricing.row_custom_status.component.new_custom_status_modal.save"
                        defaultMessage="Save" />
                </ActionButton>
            </Modal.Footer>
        </Modal>
    )
}

export default ItemBulkUpdateRowCustomStatusModal










// WEBPACK FOOTER //
// ./src/common/quote/component/ItemBulkUpdateRowCustomStatusModal.tsx